import { useParams, Link } from "react-router-dom";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import { Button, MenuItem, Box, Grid, Typography } from "@mui/material";

const HeaderAddNewMeasurement = (props) => {
  return (
    <Box sx={{ pb: 5 }}>
      <Box sx={{ mt: -2, mb: 1 }}>
        <MenuItem
          className="backlink"
          component={Link}
          sx={{
            p: "0",
          }}
          to={`/sites/${props.siteId}`}
        >
          <Grid container>
            <Grid
              item
              sx={{
                alignItems: "center",
                display: "flex",
                overflow: "hidden",
                pr: ".5em",
              }}
            >
              <ArrowBackIcon fontSize="small" />
            </Grid>
            <Grid
              item
              sx={{
                alignItems: "center",
                display: "flex",
                overflow: "hidden",
              }}
            >
              <Typography variant="subtitle2">Site</Typography>
              {/* <Typography variant="subtitle2">
                {props.formData.registrationPeriod === "Before Works" &&
                props.formData.roomDisposalDependingBeforeWorks ===
                  "Stacked Rooms"
                  ? `${props.formData.stackedRoom1Name} - ${props.formData.stackedRoom2Name}`
                  : props.formData.registrationPeriod === "Before Works" &&
                    props.formData.roomDisposalDependingBeforeWorks ===
                      "Side By Side Rooms"
                  ? `${props.formData.sideRoom1Name} - ${props.formData.sideRoom2Name}`
                  : props.formData.registrationPeriod === "After Works" &&
                    props.formData.roomDisposalDependingAfterWorks ===
                      "Stacked Rooms"
                  ? `${props.formData.stackedRoom1Name} - ${props.formData.stackedRoom2Name}`
                  : props.formData.registrationPeriod === "After Works" &&
                    props.formData.roomDisposalDependingAfterWorks ===
                      "Side By Side Rooms"
                  ? `${props.formData.sideRoom1Name} - ${props.formData.sideRoom2Name}`
                  : "error"}
              </Typography> */}
              {/* <Typography>Site</Typography> */}
            </Grid>
          </Grid>
        </MenuItem>
      </Box>
      <Grid container justifyContent="space-between" spacing={3}>
        <Grid
          item
          sx={{
            alignItems: "center",
            display: "flex",
            overflow: "hidden",
          }}
        >
          <div>
            <Typography variant="h4">
              <span style={{ color: "rgb(51, 153, 255)" }}>Create</span> new
              measurement
            </Typography>
            {/* <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <CheckCircleIcon fontSize="small" color="success" />

              <Typography
                color="textSecondary"
                variant="subtitle2"
                sx={{ ml: 1 }}
              >
                test1
              </Typography>
              <Typography variant="subtitle2" sx={{ ml: 1 }}>
                test2
              </Typography>
            </Box> */}
          </div>
        </Grid>
      </Grid>
    </Box>
  );
};

export default HeaderAddNewMeasurement;
